import { ModuleNode } from "../types";

// Data Estate
export const xOpsModule: ModuleNode = {
  key: "xops",
  title: "D&AI Monthly XOps",
  pages: [
    {
      key: "executive-summary",
      title: "Summary",
      route: "/D&AIXOps/Summary",
      items: [
        { key: "incidents-by-priority", label: "Incidents By Priority", tags: ["incidents"] },
        { key: "platform-availability",  label: "Platform Availability",  tags: ["Platform","Availability"] },
        { key: "p3-incidents", label: "P3 Incidents", tags: ["p3","incidents"] },
        { key: "happy-signal", label: "Happy Signal (NPS Score)", tags: ["Happy","signal","NPS","Score"] },
        { key: "incident-intake-channel-metrics", label: "Incident Intake Channel Metrics", tags: ["Incident","Intake","Channel", "Metrics"] },
        { key: "incident-resolution-metrics",       label: "Incident Resolution Metrics", tags: ["Incident","Resolution","Metrics"] },
        { key: "top-10-technologies", label: "Top 10 Technologies",  tags: ["top","technologies"] },
        { key: "insights", label: "Insights/Actions",   tags: ["insights","actions"] },
      ],
    },

    {
      key: "topicofthemonth",
      title: "Topic of the Month",
      route: "/D&AIXOps/misc/topicOfTheMonth",
      items: [
        { key: "insights",  label: "Insights/Actions",     tags: ["insights","actions"] },
      ],
    },

    {
      key: "mim-reports",
      title: "MIM Reports",
      route: "/D&AIXOps/itsm/MIMReports",
      items: [
        { key: "mims",   label: "MIMs",   tags: ["mims","preventive"] },
        { key: "major-problem-backlog", label: "Major Problem Backlog", tags: ["major","problem", "backlog"] },
        { key: "mim-metrics",   label: "MIM Metrics", tags: ["mim","metrics"] },
        { key: "problem-tickets", label: "Problem Tickets", tags: ["problem","tickets"] },
        { key: "problem-tickets-metrics",   label: "Problem Tickets Metrics", tags: ["problem","tickets","metrics"] },
        { key: "insights", label: "Insights/Actions", tags: ["insights","actions"] },
      ],
    },

    {
      key: "app-product-metrics",
      title: "App/Product Metrics",
      route: "/D&AIXOps/App-Product-Metrics",
      items: [
        { key: "ap-metrics",   label: "App/Product Metrics",   tags: ["apps","products"] },
      ],
    },
    {
      key: "sector-metrics",
      title: "Sector Metrics",
      route: "/D&AIXOps/segments/SectorMetrics",
      items: [
        { key: "mims",   label: "MIMs",   tags: ["mims","preventive"] },
        { key: "major-problem-backlog", label: "Major Problem Backlog", tags: ["major","problem", "backlog"] },
        { key: "mim-metrics",   label: "MIM Metrics", tags: ["mim","metrics"] },
        { key: "problem-tickets", label: "Problem Tickets", tags: ["problem","tickets"] },
        { key: "problem-tickets-metrics",   label: "Problem Tickets Metrics", tags: ["problem","tickets","metrics"] },
        { key: "top-technologies", label: "Top Technologies", tags: ["top","technologies"] },
        { key: "insights", label: "Insights/Actions", tags: ["insights","actions"] },
      ],
    },

    {
      key: "pipeline-metrics",
      title: "Pipeline Metrics",
      route: "/D&AIXOps/segments/capability/pipelineMatrics",
      items: [
        { key: "top-technologies", label: "Top Technologies", tags: ["top","technologies"] },
        { key: "insights", label: "Insights/Actions", tags: ["insights","actions"] },
      ],
    },

    {
      key: "platformOps-metrics",
      title: "Platform Ops Metrics",
      route: "/D&AIXOps/segments/capability/platformOpsMatrics",
      items: [
        { key: "platforms", label: "Platforms", tags: ["platforms"] },
        { key: "insights", label: "Insights/Actions", tags: ["insights","actions"] },
      ],
    },
    {
      key: "program-metrics",
      title: "Program Metrics",
      route: "/D&AIXOps/segments/programMetrics",
      items: [
        { key: "top-programs", label: "Top Programs", tags: ["top", "programs"] },
        { key: "insights", label: "Insights/Actions", tags: ["insights","actions"] },
      ],
    },
    {
      key: "finOps-metrics",
      title: "FinOps Metrics",
      route: "/finops/executive",
      items: [
        { key: "azure-cost",          label: "Azure Cost",                         tags: ["azure","cost","software","hardware","labor"] },
        { key: "data-viz-cost",       label: "Data Visualization Platform Cost",   tags: ["data","visualization","platform","cost","software","hardware","labor"] },
        { key: "integration-cost",    label: "Integration (Informatica) Platform Cost", tags: ["integration","informatica","platform","cost","software","hardware","labor"] },
        { key: "virtualization-cost", label: "Data Virtualization Platform Cost",  tags: ["data","virtualization","platform","cost","software","hardware","labor"] },
        { key: "other-platforms-cost",label: "Other Platforms Cost (YTD)",         tags: ["other","platforms","cost","ytd","software","hardware","labor"] },
        { key: "onprem-vs-cloud-cost",label: "OnPrem Vs Cloud Cost",               tags: ["onprem","cloud","cost","software","hardware","labor"] },
        {
          key: "data-visualization-platform-cost-breakups",
          label: "Data Visualization Platform Cost Breakups",
          tags: ["data", "visualization", "platform", "cost", "breakups"],
          drawerType: "FINOPS_COST_BREAKUP",
          drawerProps: {
                title: "Data Visualization Platform Cost",
                selectedDate: "",
                sector: []
              }
          },
          {
          key: "integration-(informatica)-platform-cost-breakups",
          label: "Integration (Informatica) Platform Cost Breakups",
          tags: ["integration", "informatica", "platform", "cost", "breakups"],
          drawerType: "FINOPS_COST_BREAKUP",
          drawerProps: {
                title: "Integration (Informatica) Platform Cost",
                selectedDate: "",
                sector: []
              }
          },
          {
          key: "data-virtualization-platform-cost-breakups",
          label: "Data Virtualization Platform Cost Breakups",
          tags: ["data", "virtualization", "platform", "cost", "breakups"],
          drawerType: "FINOPS_COST_BREAKUP",
          drawerProps: {
                title: "Data Virtualization Platform Cost",
                selectedDate: "",
                sector: []
              }
          },
          {
          key: "other-platforms-cost-(ytd)-breakups",
          label: "Other Platforms Cost (YTD) Breakups",
          tags: ["other", "platforms", "ytd", "cost", "breakups"],
          drawerType: "FINOPS_COST_BREAKUP",
          drawerProps: {
                title: "Other Platforms Cost (YTD)",
                selectedDate: "",
                sector: []
              }
          },
      ]
    },
    {
      key: "happy-signals-overview",
      title: "Happy Signals Overview",
      route: "/D&AIXOps/experience/HappySignals",
      items: [
        { key: "happiness-index",      label: "Happiness Index",        tags: ["happiness","index"] },
        { key: "average-lost-time",    label: "Average Lost Time",      tags: ["average","lost","time"] },
        { key: "happiness-index-trend",label: "Happiness Index Trend",  tags: ["happiness","index","trend"] },
        { key: "response-volume",      label: "Response Volume",        tags: ["response","volume"] },
        { key: "insights-actions",     label: "Insights/Actions",       tags: ["insights","actions"] },
      ]
    },
    {
      key: "biOps-metrics",
      title: "BI Ops Metrics",
      route: "/D&AIXOps/segments/capability/DepartmentLevelMetrics",
      items: [
        { key: "top-applications", label: "Top Applications", tags: ["top", "applications"] },
        { key: "insights", label: "Insights/Actions", tags: ["insights","actions"] },
      ],
    },
    {
      key: "DMO-metrics",
      title: "DMO Metrics",
      route: "/D&AIXOps/segments/capability/DMOMetrics",
      items: [
        { key: "DMO", label: "DMO Metrics", tags: ["DMO", "Metrics"] },
      ],
    },
    {
      key: "AI/MLOps-metrics",
      title: "AI/ML Ops Metrics",
      route: "/D&AIXOps/segments/capability/AIMLMetrics",
      items: [
        { key: "top-technologies", label: "Top Technologies", tags: ["top","technologies"] },
        { key: "insights", label: "Insights/Actions", tags: ["insights","actions"] },
      ],
    },
    {
      key: "NPI-dashboard",
      title: "NPI Dashboard",
      route: "/D&AIXOps/misc/npiDashboards",
      items: [
        { key: "NPI", label: "NPI Dashboard", tags: ["NPI", "Dashboard"] },
      ],
    },
    {
      key: "Vendor-management",
      title: "Vendor Management",
      route: "/D&AIXOps/misc/vendorManagement",
      items: [
        { key: "Vendor", label: "Vendor Management", tags: ["Vendor", "Management"] },
      ],
    },
  ],
  submodules: [
    //summary module pages
    {
        key: "summary",
        title: "Summary",
        route: "/DAIXOps/summary/overview",
        pages: [
          {
            key: "overview",
            title: "Overview",
            route: "/DAIXOps/summary/overview",
            items: [
              { key: "mims",   label: "MIMs",   tags: ["mims","preventive"] },
              { key: "p3-incidents", label: "P3 Incidents", tags: ["p3","incidents"] },
              { key: "major-problem-backlog", label: "Major Problem Backlog", tags: ["major","problem", "backlog"] },
            ],
          },
        ]
    }
  ]
};
